import { ReactNode } from "react";
import { Divider, Pill, Stack, Typography } from "@financeable-com-au/financeable-ui";
import { fCurrencyDecimal } from "@/utils/formatNumber";
import { INVOICE_CURRENCY, INVOICE_GST_RATE, INVOICE_SECTIONS } from "@/constants";
import { SummaryProps } from "@/utils/interface";
import SectionCard from "./SectionCard";

interface RowProps {
  label: ReactNode;
  value: ReactNode;
  emphasize?: boolean;
  muted?: boolean;
}

const Row = ({ label, value, emphasize, muted }: RowProps) => {
  const level = emphasize ? "title-sm" : "body-sm";
  const weight = emphasize ? { fontWeight: 700 } : undefined;
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography level={level} textColor={muted ? "neutral.500" : undefined} style={weight}>
        {label}
      </Typography>
      {typeof value === "string" || typeof value === "number" ? (
        <Typography level={level} style={weight}>
          {value}
        </Typography>
      ) : (
        value
      )}
    </Stack>
  );
};

const Summary = ({
  subtotal,
  gst,
  total,
  billingMonth,
  billingYear,
  loading,
}: SummaryProps) => {
  const amount = (val: number) => fCurrencyDecimal(loading ? 0 : val);

  return (
    <SectionCard title={INVOICE_SECTIONS.summary} subtitle="Invoice summary and details.">
      <Stack direction="column" rowGap={2}>
        <Row label="Subtotal" value={amount(subtotal)} />
        <Row label={`GST (${INVOICE_GST_RATE * 100}%)`} value={amount(gst)} />
        <Divider />
        <Row emphasize label="Total" value={`${amount(total)} ${INVOICE_CURRENCY}`} />
        <Divider />
        <Row muted label="Billing period" value={`${billingMonth} ${billingYear}`} />
        <Row muted label="Currency" value={INVOICE_CURRENCY} />
        <Row muted label="Type" value={<Pill accent={300}>One-off</Pill>} />
      </Stack>
    </SectionCard>
  );
};

export default Summary;
